import { TimeValidationErrorRecord } from "./interfaces";

export default class TimeValidationError extends Error {
    constructor(
        message: string,
        public readonly errors: readonly TimeValidationErrorRecord[],
    ) {
        super(message);
        this.name = "TimeValidationError";
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
